export enum CommonRegex {
  BAD_CHARACTERS = '{}[]^"~%',
  CONTACT_NAME_PATTERN = '^[\\S]{0,20}(\\s[\\S\\s]{0,20})?$',
  NAME_FIELD_BAD_CHARACTERS = '{}[]^~',
}
